export default __webpack_public_path__ + "static/media/stop-watch.306dd10a.svg";